import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type ReadMaintenanceAreasQueryVariables = {
  search?: Types.Maybe<Types.Scalars['String']>
};


export type ReadMaintenanceAreasQuery = (
  { __typename?: 'Query' }
  & { maintenanceAreas: Array<(
    { __typename?: 'MaintenanceArea' }
    & Pick<Types.MaintenanceArea, '_id' | '_deleted' | 'department' | 'maintenanceArea' | 'created' | 'modified' | 'inactive' | 'annotation'>
    & { maintenanceHead: Types.Maybe<Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'type' | 'upn' | 'firstName' | 'lastName' | 'name' | 'email' | 'department' | 'roles'>
    )>>, createdBy: Types.Maybe<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'type' | 'upn' | 'firstName' | 'lastName' | 'name' | 'email' | 'department' | 'roles'>
    )>, modifiedBy: Types.Maybe<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'type' | 'upn' | 'firstName' | 'lastName' | 'name' | 'email' | 'department' | 'roles'>
    )> }
  )> }
);

export type CreateMaintenanceAreaMutationVariables = {
  input: Types.MaintenanceAreaInsertInput
};


export type CreateMaintenanceAreaMutation = (
  { __typename?: 'Mutation' }
  & { createMaintenanceArea: (
    { __typename?: 'MaintenanceArea' }
    & Pick<Types.MaintenanceArea, '_id'>
  ) }
);

export type UpdateMaintenanceAreaMutationVariables = {
  id: Types.Scalars['ID'],
  update: Types.MaintenanceAreaUpdateInput
};


export type UpdateMaintenanceAreaMutation = (
  { __typename?: 'Mutation' }
  & { updateMaintenanceArea: (
    { __typename?: 'MaintenanceArea' }
    & Pick<Types.MaintenanceArea, '_id'>
  ) }
);

export type DeleteMaintenanceAreaMutationVariables = {
  ids: Array<Types.Scalars['ID']>
};


export type DeleteMaintenanceAreaMutation = (
  { __typename?: 'Mutation' }
  & { deleteMaintenanceAreas: Array<(
    { __typename?: 'MaintenanceArea' }
    & Pick<Types.MaintenanceArea, '_id'>
  )> }
);

export const ReadMaintenanceAreasDocument = gql`
    query ReadMaintenanceAreas($search: String) {
  maintenanceAreas(filter: {department: {REGEX: $search, OPTIONS: "i"}}, sort: {department: ASC}) {
    _id
    _deleted
    department
    maintenanceArea
    maintenanceHead {
      _id
      type
      upn
      firstName
      lastName
      name
      email
      department
      roles
    }
    createdBy {
      _id
      type
      upn
      firstName
      lastName
      name
      email
      department
      roles
    }
    created
    modifiedBy {
      _id
      type
      upn
      firstName
      lastName
      name
      email
      department
      roles
    }
    modified
    inactive
    annotation
  }
}
    `;

    export function useReadMaintenanceAreasQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReadMaintenanceAreasQuery, ReadMaintenanceAreasQueryVariables>) {
      return ApolloReactHooks.useQuery<ReadMaintenanceAreasQuery, ReadMaintenanceAreasQueryVariables>(ReadMaintenanceAreasDocument, baseOptions);
    };
      export function useReadMaintenanceAreasLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReadMaintenanceAreasQuery, ReadMaintenanceAreasQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ReadMaintenanceAreasQuery, ReadMaintenanceAreasQueryVariables>(ReadMaintenanceAreasDocument, baseOptions);
      };
      
export type ReadMaintenanceAreasQueryHookResult = ReturnType<typeof useReadMaintenanceAreasQuery>;
export type ReadMaintenanceAreasQueryResult = ApolloReactCommon.QueryResult<ReadMaintenanceAreasQuery, ReadMaintenanceAreasQueryVariables>;
export const CreateMaintenanceAreaDocument = gql`
    mutation CreateMaintenanceArea($input: MaintenanceAreaInsertInput!) {
  createMaintenanceArea(input: $input) {
    _id
  }
}
    `;
export type CreateMaintenanceAreaMutationFn = ApolloReactCommon.MutationFunction<CreateMaintenanceAreaMutation, CreateMaintenanceAreaMutationVariables>;

    export function useCreateMaintenanceAreaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMaintenanceAreaMutation, CreateMaintenanceAreaMutationVariables>) {
      return ApolloReactHooks.useMutation<CreateMaintenanceAreaMutation, CreateMaintenanceAreaMutationVariables>(CreateMaintenanceAreaDocument, baseOptions);
    };
export type CreateMaintenanceAreaMutationHookResult = ReturnType<typeof useCreateMaintenanceAreaMutation>;
export type CreateMaintenanceAreaMutationResult = ApolloReactCommon.MutationResult<CreateMaintenanceAreaMutation>;
export type CreateMaintenanceAreaMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateMaintenanceAreaMutation, CreateMaintenanceAreaMutationVariables>;
export const UpdateMaintenanceAreaDocument = gql`
    mutation UpdateMaintenanceArea($id: ID!, $update: MaintenanceAreaUpdateInput!) {
  updateMaintenanceArea(id: $id, update: $update) {
    _id
  }
}
    `;
export type UpdateMaintenanceAreaMutationFn = ApolloReactCommon.MutationFunction<UpdateMaintenanceAreaMutation, UpdateMaintenanceAreaMutationVariables>;

    export function useUpdateMaintenanceAreaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMaintenanceAreaMutation, UpdateMaintenanceAreaMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdateMaintenanceAreaMutation, UpdateMaintenanceAreaMutationVariables>(UpdateMaintenanceAreaDocument, baseOptions);
    };
export type UpdateMaintenanceAreaMutationHookResult = ReturnType<typeof useUpdateMaintenanceAreaMutation>;
export type UpdateMaintenanceAreaMutationResult = ApolloReactCommon.MutationResult<UpdateMaintenanceAreaMutation>;
export type UpdateMaintenanceAreaMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateMaintenanceAreaMutation, UpdateMaintenanceAreaMutationVariables>;
export const DeleteMaintenanceAreaDocument = gql`
    mutation DeleteMaintenanceArea($ids: [ID!]!) {
  deleteMaintenanceAreas(ids: $ids) {
    _id
  }
}
    `;
export type DeleteMaintenanceAreaMutationFn = ApolloReactCommon.MutationFunction<DeleteMaintenanceAreaMutation, DeleteMaintenanceAreaMutationVariables>;

    export function useDeleteMaintenanceAreaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMaintenanceAreaMutation, DeleteMaintenanceAreaMutationVariables>) {
      return ApolloReactHooks.useMutation<DeleteMaintenanceAreaMutation, DeleteMaintenanceAreaMutationVariables>(DeleteMaintenanceAreaDocument, baseOptions);
    };
export type DeleteMaintenanceAreaMutationHookResult = ReturnType<typeof useDeleteMaintenanceAreaMutation>;
export type DeleteMaintenanceAreaMutationResult = ApolloReactCommon.MutationResult<DeleteMaintenanceAreaMutation>;
export type DeleteMaintenanceAreaMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteMaintenanceAreaMutation, DeleteMaintenanceAreaMutationVariables>;